import Vue from 'vue';
import VueRouter from 'vue-router';

import routes from './routes';

Vue.use(VueRouter);

const Router = new VueRouter({
  /*
   * NOTE! Change Vue Router mode from quasar.conf.js -> build -> vueRouterMode
   *
   * If you decide to go with "history" mode, please also set "build.publicPath"
   * to something other than an empty string.
   * Example: '/' instead of ''
   */

  // Leave as is and change from quasar.conf.js instead!
  mode: process.env.VUE_ROUTER_MODE,
  base: process.env.VUE_ROUTER_BASE,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

Router.beforeEach((to, from, next) => {
  console.log('ROUTER BEFORE', from.path, '>>', to.path, to.query);
  next();
});

Router.afterEach((to, from) => {
  console.log('ROUTER AFTER', from.path, '>>', to.path);
  Router.jumpFrom = from.path;
});

Router.jumpBack = () => {
  if (Router.jumpFrom) {
    Router.push(Router.jumpFrom);
  } else {
    Router.push('/');
  }
};

export default Router;



// WEBPACK FOOTER //
// ./src/router/index.js